module.exports = __webpack_public_path__ + "img/icon6.affff951.gif";